import { render } from "./ServicesDisplay.vue?vue&type=template&id=3f8315b2&scoped=true"
import script from "./ServicesDisplay.vue?vue&type=script&lang=js"
export * from "./ServicesDisplay.vue?vue&type=script&lang=js"

import "./ServicesDisplay.vue?vue&type=style&index=0&id=3f8315b2&scoped=true&lang=css"

import exportComponent from "/home/tantonj/Documents/GitHub/TantonSoftwareSolutions/tantonsoftwaresolutions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8315b2"]])

export default __exports__